module.exports = __webpack_public_path__ + "static/media/users-past.880c222c.svg";